<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="pop-up-position">
    <div class="card shadow">
      <div class="card-body">
        <div class="row align-items-center">
          <div class="col-auto icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_2770_7117)">
                <path
                  d="M23.2969 18.8281C3.81169 18.8281 4.68052 18.8318 4.6793 18.8216C4.46573 17.1115 4.47431 17.2209 4.48823 17.2188C13.8384 17.1702 -8.5192 17.2219 21.7416 17.2219C23.0023 17.2219 23.9531 16.2667 23.9531 15V5.47266C23.9531 4.54922 23.202 3.79664 22.2785 3.795L16.4576 3.78497V2.29688C16.4576 1.46977 15.7847 0.796875 14.9576 0.796875H13.5527C12.7258 0.796875 12.0532 1.46958 12.0532 2.29641V3.77737L5.80894 3.7665L5.34089 1.18875C5.21588 0.499969 4.617 0 3.91692 0H0.703125C0.314812 0 0 0.314812 0 0.703125C0 1.09144 0.314812 1.40625 0.703125 1.40625C4.10602 1.40625 3.94777 1.38755 3.95728 1.43995C4.72017 5.64145 4.23464 2.70502 6.28134 15.8032L4.48186 15.8126C3.63684 15.8158 2.97905 16.5576 3.08452 17.4016L3.28383 18.9961C3.37209 19.702 3.97514 20.2344 4.68656 20.2344H5.93437C5.05312 21.9455 6.30127 24 8.23439 24C10.1666 24 11.4161 21.9463 10.5344 20.2344H17.2313C16.35 21.9455 17.5981 24 19.5313 24C21.4635 24 22.7129 21.9464 21.8312 20.2344H23.2969C23.6852 20.2344 24 19.9196 24 19.5313C24 19.143 23.6852 18.8281 23.2969 18.8281ZM13.4595 2.29641C13.4595 2.24498 13.5013 2.20312 13.5527 2.20312H14.9577C15.0094 2.20312 15.0514 2.24517 15.0514 2.29688V7.5C15.0514 7.88831 15.3662 8.20312 15.7545 8.20312H16.7987L14.6073 10.3959C14.4128 10.5905 14.098 10.5905 13.9035 10.3959L11.712 8.20312H12.7563C13.1446 8.20312 13.4594 7.88831 13.4594 7.5V2.29641H13.4595ZM12.0532 5.18363V6.79688H10.8795C9.93609 6.79688 9.46144 7.94034 10.1288 8.60831L12.9089 11.39C13.653 12.1345 14.8578 12.1346 15.602 11.39L18.382 8.60831C19.049 7.94095 18.5756 6.79688 17.6314 6.79688H16.4577V5.19122L22.2761 5.20125C22.4255 5.20148 22.5469 5.32327 22.5469 5.47266V15C22.5469 15.4878 22.2232 15.8156 21.7416 15.8156H7.70662L6.04364 5.17317L12.0532 5.18363ZM9.41405 21.414C9.41405 22.0645 8.88483 22.5938 8.23434 22.5938C7.58386 22.5938 7.05469 22.0645 7.05469 21.414C7.05469 20.7636 7.58391 20.2343 8.23439 20.2343C8.88488 20.2343 9.41405 20.7636 9.41405 21.414ZM20.7109 21.414C20.7109 22.0645 20.1817 22.5938 19.5313 22.5938C18.8808 22.5938 18.3516 22.0645 18.3516 21.414C18.3516 20.7636 18.8808 20.2343 19.5313 20.2343C20.1817 20.2343 20.7109 20.7636 20.7109 21.414Z"
                  fill="#AA874A"
                />
              </g>
              <defs>
                <clipPath id="clip0_2770_7117">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div class="col ps-0">
            <div class="text-secondary-05">Produsul a fost adăugat cu succes în coș.</div>
          </div>
        </div>
        <div class="row mt-3 d-none d-sm-flex">
          <div class="col-6">
            <router-link
              class="button btn-small btn-primary-solid w-100 text-center h-100"
              :to="{ name: 'Cart' }"
              aria-label="Finalizeaza comanda"
            >
              Finalizează comanda
            </router-link>
          </div>
          <div class="col-6">
            <button
              type="button"
              class="button btn-small btn-neutral-outlined w-100 text-center"
              @click="$emit('close-pop-up')"
            >
              Continuă cumpăraturile
            </button>
          </div>
        </div>
      </div>
      <div class="round-time-bar-absolute">
        <div class="round-time-bar" data-style="smooth" style="--duration: 8">
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductAddedToCartPopUpComponent',
  emits: ['close-pop-up'],
  props: {
    showSuccessPopup: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    // RatingComponent,
  },
  methods: {},
  watch: {
    showSuccessPopup: {
      handler(newValue) {
        if (newValue === true) {
          setTimeout(() => this.$emit('close-pop-up'), 8000); // 8000
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style scoped>
.round-time-bar-absolute {
  bottom: -0.7px;
  left: 0px;
  right: 0;
  border-bottom-left-radius: 8px;
  position: absolute;
}

.round-time-bar {
  overflow: hidden;
  border-bottom-left-radius: 8px;
  background-color: transparent !important;
}
.round-time-bar div {
  height: 3px;
  animation: roundtime calc(var(--duration) * 1s) steps(var(--duration)) forwards;
  transform-origin: left center;
  background: #cccccccc;
}

@media (min-width: 576px) {
  .round-time-bar div {
    height: 5px;
  }
  .round-time-bar-absolute {
    bottom: 0;
  }
}

.round-time-bar[data-style='smooth'] div {
  animation: roundtime calc(var(--duration) * 1s) linear forwards;
}

.round-time-bar[data-style='fixed'] div {
  width: calc(var(--duration) * 5%);
}

.round-time-bar[data-color='blue'] div {
  background: linear-gradient(to bottom, #64b5f6, #1565c0);
}

@keyframes roundtime {
  to {
    /* More performant than `width` */
    transform: scaleX(0);
  }
}

.btn-small {
  font-size: 10px;
  padding: 2px 10px;
}

@media (min-width: 576px) {
  .btn-small {
    font-size: 11px;
    padding: 4px 10px;
  }
}

.card {
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid transparent;
  position: relative;
}
.pop-up-position {
  position: fixed;
  z-index: 6000;
  top: 85px;
}

@media (max-width: 576px) {
  .pop-up-position {
    right: 0;
    left: 0;
  }
  .text-secondary-05 {
    font-size: 13px;
  }
  .card-body {
    padding: 8px;
  }
  .card {
    max-width: 300px;
    margin: auto;
  }
  .card-body .icon svg {
    max-width: 20px;
  }
}

@media (min-width: 576px) {
  .pop-up-position {
    right: 12px;
  }
}

@media (min-width: 1200px) {
  .pop-up-position {
    top: 12px;
  }
}
</style>
